type Tier = {
  minQuantity: number;
  rate: number;
  baseFee: number;
};

type Args = {
  quantity: number;
  tiers: Tier[];
  itemsPerCase: number;
};

type PricingTier = Tier & {
  rateEach: number;
};

const getPricingTier = ({ quantity = 1, tiers = [], itemsPerCase = 1 }: Args): PricingTier => {
  let rates = { rate: null, baseFee: null, rateEach: null, minQuantity: 1 };

  if (tiers.length <= 0) return rates;

  let tier = tiers[0];
  for (const t of tiers) {
    if (t.minQuantity > quantity) break;
    tier = t;
  }

  return {
    ...tier,
    rateEach: tier.rate / itemsPerCase,
  };
};

export default getPricingTier;
